import {Endpoints} from "../Endpoints";
import Backend from "../../Backend";

export default class Catalogs
{
	constructor(token)
	{
		this.backend = new Backend(token);
	}

	countries(callback)
	{
		this.backend.callBackend(`${Endpoints.catalog.country.private}/all`, callback);
	}

	contactTypes(callback)
	{
		this.backend.callBackend(`${Endpoints.catalog.contactType.private}/all`, callback);
	}

	paymentOptions(callback)
	{
		this.backend.callBackend(`${Endpoints.catalog.paymentOption.private}/all`, callback);
	}

	currencies(callback)
	{
		this.backend.callBackend(`${Endpoints.catalog.currency.private}/all`, callback);
	}

	regionByCurrency(id,callback){
		this.backend.callBackend(`${Endpoints.brand.region}/catalog/currency/${id}`,callback);
	}
	
}